<template>
  <div class="login-background d-flex align-items-center justify-content-center">
    <amplify-authenticator username-alias="email" />
  </div>
</template>

<script>

export default {
};
</script>